import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import Antd from 'ant-design-vue';
import ReadMore from 'vue-read-more';
import 'ant-design-vue/dist/antd.css';
import { toUpper } from 'lodash';

import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import {} from '@/util';

import app from './App';
import store from './store';
import router from './router';
import i18n from './i18n';

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(Antd);
Vue.use(ReadMore);
Vue.filter('uppercase', toUpper);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  components: {
    app,
  },
  template: '<app/>',
});
